/**
 * Cookie name for storing the impersonated installation ID
 */
export const IMPERSONATED_INSTALLATION_ID_COOKIE = 'impersonated-installation-id';

/**
 * Header name for passing the impersonated installation ID
 */
export const IMPERSONATED_INSTALLATION_ID_HEADER = 'x-impersonated-installation-id';
